import { Outlet } from 'react-router-dom'
import { Header } from '@/components/layout/Header'
import { Footer } from '@/components/layout/Footer'
import { AboutModal } from '@/components/Modals/AboutModal'
import { ConfirmDialog } from '@/components/ui/ConfirmDialog'
import { TabLimitDialog } from '@/components/Modals/TabLimitDialog'

export function AuthedLayout() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100dvh',
        overflow: 'hidden',
        background: 'var(--bg-app)',
        color: 'var(--text)',
      }}
    >
      <Header />
      <main style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
        <Outlet />
      </main>
      <Footer />
      <AboutModal />
      <ConfirmDialog />
      <TabLimitDialog />
    </div>
  )
}
